// client/src/App.jsx
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import Layout from './components/Layout';
import Public from './components/Public';
import Login from './features/auth/Login';
import Welcome from './features/auth/Welcome';
import RequireAuth from './features/auth/RequireAuth';
import UsersList from './features/users/UsersList';
import Console from './features/auth/Console';
import Features from './components/Features';
import Contact from './components/Contact';
import PersistLogin from './features/auth/PersistLogin';
import ResetPassword from './components/react-dashboard/user_actions/ResetPassword';
import { useMode, ColorModeContext } from './theme';

function App() {
  const [theme, colorMode] = useMode();

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* public routes */}
            <Route index element={<Public />} />
            <Route path="features" element={<Features />} />
            <Route path="contact" element={<Contact />} />
            <Route path="login" element={<Login />} />

            {/* protected routes */}
            <Route element={<PersistLogin />}>
              <Route element={<RequireAuth />}>
                <Route path="reset-password" element={<ResetPassword />} />
                <Route path="welcome" element={<Welcome />} />
                <Route path="console/*" element={<Console />} />
                <Route path="userslist" element={<UsersList />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
